import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { Router } from '@angular/router';
import { LimiteGlobalService } from '../../limite-global.service';

@Component({
	selector: 'app-modal-aviso-financiamento-lg',
	templateUrl: './modal-aviso-financiamento-lg.component.html',
	styleUrls: ['./modal-aviso-financiamento-lg.component.styl'],
})
export class ModalAvisoFinanciamentoLgComponent {
	public title: string;
	public text: string;

	constructor(
		public dialogRef: MatDialogRef<ModalAvisoFinanciamentoLgComponent>,
		public limiteGlobalService: LimiteGlobalService,
		public router: Router
	) {}

	async onClose(goRouter?: boolean): Promise<void> {
		if (goRouter) {
			this.limiteGlobalService.setRouteredByModal();
			await this.router.navigate(['minha-conta', 'creditback']);
		}
		this.dialogRef.close();
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/limite-global/components/modal-aviso-financiamento-lg/modal-aviso-financiamento-lg.component.ts